import { centsToDecimal, formatWholeMoney } from '@campaign-manager/core/lib/utils';
import { useLocalization } from '@campaign-manager/feature/context/Localization';

import Value from '../Value';

interface Props {
  value: number | null | undefined;
  currency?: string | null | undefined;
  locale?: string | null | undefined;
  placeholder?: string;
}

export default function WholeMoneyValue({ value, placeholder }: Props) {
  const { currency, numberFormatLocale: locale } = useLocalization();
  return (
    <Value
      value={WholeMoneyValueString({ value, currency, locale })}
      placeholder={placeholder}
    />
  );
}

export function WholeMoneyValueString({ value, currency, locale }: Props) {
  return value
    ? formatWholeMoney(centsToDecimal(value), currency ?? undefined, locale ?? undefined)
    : undefined;
}
